const env="DEV";//还需要配置到webpack中
const domain={
  DEV:"//api.tuanche.com/",
  PRE:"",
  PROD:""
};
const baseUrl=domain[env];
const api={

}

const url={
  baseUrl,
  api
}

export {url};



// WEBPACK FOOTER //
// ./src/static/js/lib/url.js